import { Component, Injector, Input } from '@angular/core';
import { provideValueAccessor } from 's-ng-utils';
import { Wrapper } from 'bookraw/shared/components/form-input/wrapper';
import { NgxMatDateFormats } from '@angular-material-components/datetime-picker';
import { MAT_DATE_FORMATS } from '@angular/material/core';

export const CUSTOM_DATE_FORMATS: NgxMatDateFormats = {
  parse: {
    dateInput: 'YYYY.MM.DD.'
  },
  display: {
    dateInput: 'YYYY.MM.DD.',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  }
};

@Component({
  selector: 'ext-datepicker',
  template: `
    <mat-form-field
      class="full-width"
      appearance="standard"
      [class.mat-form-field-invalid]="ngControl.invalid"
      matTooltip="{{ tooltip }}"
      matTooltipPosition="above"
    >
      <mat-label>{{ label }}</mat-label>
      <input
        matInput
        #input
        [min]="min"
        [readonly]="true"
        [formControl]="formControl"
        [matDatepicker]="picker"
        [required]="formControl.markRequired || required"
      >
      <mat-error>{{ formControl?.getError('error') }}</mat-error>
      <mat-datepicker-toggle class="suffix-button" matSuffix [for]="picker"></mat-datepicker-toggle>
      <button *ngIf="allowClear"
        class="suffix-button"
        mat-icon-button
        mat-sm-button
        matSuffix
        [disabled]="!input.value || formControl.disabled"
        (click)="clearInput()"
      ><mat-icon>clear</mat-icon></button>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
  `,
  styles: [`
     .suffix-button {
       display: inline-block!important;
     }
  `],
  providers: [
    {provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS},
    provideValueAccessor(ExtDatepickerComponent)
  ],
})
export class ExtDatepickerComponent extends Wrapper {
  @Input() min: Date|string;
  @Input() label: string;
  @Input() allowClear: boolean = true;

  constructor(public injector: Injector) {
    super(injector);
  }

  clearInput() {
    this.formControl.setValue('');
    this.formControl.markAsTouched();
  }
}
